export default __webpack_public_path__ + "static/media/fulfil.c375308a.PNG";